export const Tarrif = [
  { label: 'Weekly', value: '1' },
  { label: 'Daily', value: '2' },
  { label: 'Monthly', value: '3' },
  { label: 'Yearly', value: '3' },
];
export const RentalType = [
  { label: 'Self Pickup', value: '2' },
  { label: 'Delivery', value: '1' },
];
export const PickupLocation = [
  { label: 'Los Angles', value: '2' },
  { label: 'New York City', value: '1' },
  { label: 'Houston', value: '3' },
  { label: 'Munich', value: '4' },
  { label: 'Montreal', value: '6' },
];

export const ReturnLocation = [
  { label: 'Los Angles', value: '2' },
  { label: 'New York City', value: '1' },
  { label: 'Houston', value: '3' },
  { label: 'Munich', value: '4' },
  { label: 'Montreal', value: '6' },
];
export const Driver = [
  { label: 'Reuben Keen', value: '1' },
  { label: 'William Jones', value: '2' },
  { label: 'Leonard Jandreau', value: '3' },
  { label: 'Adam Bolden', value: '4' },
];
export const Customer = [
  { label: 'Andrew Simons', value: '1' },
  { label: 'David Steiger', value: '2' },
  { label: 'Darin Mabry', value: '3' },
  { label: 'Mark Neiman', value: '4' },
];
export const Country = [
  { label: 'USA', value: '1' },
  { label: 'Canada', value: '2' },
  { label: 'UK', value: '3' },
];
export const State = [
  { label: 'California', value: '1' },
  { label: 'New York', value: '2' },
  { label: 'Florida', value: '3' },
];
export const City = [
  { label: 'Los Angeles', value: '1' },
  { label: 'San Diego', value: '2' },
  { label: 'Fresno', value: '3' },
];
export const Status = [
  { label: 'Disabled', value: '1' },
  { label: 'Enabled', value: '2' },
];
export const Owner = [
  { label: 'Adrian Saurez', value: '1' },
  { label: 'Jessica David', value: '2' },
  { label: 'Hendrita Margerate', value: '3' },
  { label: 'Silvaa Andrew', value: '4' },
];
export const Industry = [
  { label: 'Peer-to-Peer Car Renta', value: '1' },
  { label: 'Electric and Hybrid Vehicles', value: '2' },
  { label: 'Subscription Services', value: '3' },
];
export const TeamSize = [
  { label: '1-10', value: '1' },
  { label: '11-15', value: '2' },
  { label: '50+', value: '3' },
];
export const Seperator = [
  { label: '.', value: '1' },
  { label: ',', value: '2' },
];
export const TimeZone = [
  { label: '(+5:30) GMT', value: '1' },
  { label: '(+11:30) INR', value: '2' },
];
export const Week = [
  { label: 'Monday', value: '1' },
  { label: 'Tuesday', value: '2' },
  { label: 'Wednesday', value: '3' },
  { label: 'Thursday', value: '4' },
  { label: 'Friday', value: '5' },
];
export const DateFormat = [
  { label: '01 Jan 2025', value: '1' },
  { label: 'Jan 02 2025', value: '2' },
  { label: '2025 Jan 02', value: '3' },
  { label: '2025 02 Jan', value: '4' },
];
export const TimeFormat = [
  { label: '12 hrs', value: '1' },
  { label: '24 hrs', value: '2' },
];
export const Language = [
  { label: 'Gremany', value: '1' },
  { label: 'French', value: '2' },
  { label: 'Gremany', value: '3' },
];
export const CurrencySymbol = [
  { label: '$', value: '1' },
  { label: '€', value: '2' },
];
export const CurrencyPosition = [
  { label: '100$', value: '1' },
  { label: '$100', value: '2' },
];
export const Currency = [
  { label: 'USD', value: '1' },
  { label: 'EURO', value: '2' },
];
export const ReservationTime = [
  { label: '1 Day', value: '1' },
  { label: '1 Week', value: '2' },
  { label: '1 Month', value: '3' },
];
export const BufferTime = [
  { label: '1 Day', value: '1' },
  { label: '2 Day', value: '2' },
  { label: '3 Day', value: '3' },
  { label: '4 Day', value: '4' },
];
export const Numbers = [
  { label: '5', value: '1' },
  { label: '10', value: '2' },
];
export const Module = [
  { label: 'Drivers', value: '1' },
  { label: 'Maintenance', value: '2' },
];
export const InputType = [
  { label: 'Select', value: '1' },
  { label: 'Number', value: '2' },
];
export const Position = [
  { label: 'Left', value: '1' },
  { label: 'Right', value: '2' },
];
export const TaxType = [
  { label: '%', value: '1' },
  { label: 'Direct', value: '2' },
];
export const OneTime = [
  { label: 'One Time', value: '1' },
  { label: 'Per Day', value: '2' },
];
export const Gender = [
  { label: 'Male', value: '1' },
  { label: 'Female', value: '2' },
];
export const Brand = [
  { label: 'Toyota', value: '1' },
  { label: 'Audi', value: '2' },
  { label: 'Lamborghini', value: '3' },
];
export const DamageLocation = [
  { label: 'Interior', value: '1' },
  { label: 'Exterior', value: '2' },
];
export const DamageType = [
  { label: 'Scratch', value: '1' },
  { label: 'Dent', value: '2' },
  { label: 'Crack', value: '3' },
  { label: 'Clip', value: '4' },
];
export const CarType = [
  { label: 'Sedan', value: '1' },
  { label: 'Hatchback', value: '2' },
  { label: 'SUV', value: '3' },
  { label: 'Coupes', value: '4' },
];
export const CarModal = [
  { label: 'Urban Cruiser', value: '1' },
  { label: 'Fortuner', value: '2' },
  { label: 'V8', value: '3' },
  { label: 'Huracan', value: '4' },
];
 
// export const Category = [
//   { label: 'Car', value: '1' },
//   { label: 'Bike', value: '2' },
//   { label: 'Truck', value: '3' },
// ];
export const Fuel = [
  { label: 'Petrol', value: '1' },
  { label: 'Diesel', value: '2' },
  { label: 'Electric', value: '3' },
];
export const Platform = [
  { label: 'Youtube', value: '1' },
  { label: 'Vimeo', value: '2' },
];
export const Seater = [
  { label: '2 Seater', value: '1' },
  { label: '4 Seater', value: '2' },
  { label: '5 Seater', value: '3' },
];
export const Doors = [
  { label: '2 Doors', value: '1' },
  { label: '4 Doors', value: '2' },
  { label: '5 Doors', value: '3' },
];
export const Transmission = [
  { label: 'Automatic', value: '1' },
  { label: 'Semi-Automatic', value: '2' },
  { label: 'Manual', value: '3' },
];
export const MainLocation = [
  { label: 'Johnson Dealer Zone', value: '1' },
  { label: 'Miller Auto Trade Zone', value: '2' },
  { label: 'Thompson Dealer Parking', value: '3' },
];
 
export const DrivingType = [
  { label: 'Self-Drive', value: '1' },
  { label: 'Chauffeur-Driven', value: '2' },
  { label: 'One-Way Rental', value: '3' },
  { label: 'Long-Term Lease', value: '4' },
  { label: 'Hourly Rental', value: '5' },
];

export const Role = [
  { label: 'Admin', value: '1' },
  { label: 'Manager', value: '2' },
  { label: 'Customer', value: '3' },
  { label: 'Inspector', value: '4' },
];

export const Category = [
  { label: 'Payment Issue', value: '1' },
  { label: 'Car Not Available', value: '2' },
  { label: 'Refund Request', value: '3' },
];

export const Priority = [
  { label: 'Low', value: '1' },
  { label: 'Medium', value: '2' },
  { label: 'High', value: '3' },
];

export const AnnouncementType = [
  { label: 'New Rental Service', value: '1' },
  { label: 'Special Offer', value: '2' },
  { label: 'Seasonal Promotion', value: '3' },
];

export const Users = [
  { label: 'Customer', value: '1' },
  { label: 'Admin', value: '2' },
  { label: 'Manager', value: '3' },
];

export const FaqCategory = [
  { label: 'Rental Policies', value: '1' },
  { label: 'Payments', value: '2' },
  { label: 'Insurance', value: '3' },
  { label: 'Booking', value: '3' },
  { label: 'Requirements', value: '3' },
];

export const Ratings = [
  { label: '5 Star', value: '1' },
  { label: '4 Star', value: '2' },
  { label: '3 Star', value: '3' },
  { label: '2 Star', value: '3' },
  { label: '1 Star', value: '3' },
];

export const StateName = [
  { label: 'California', value: '1' },
  { label: 'New York', value: '2' },
  { label: 'Texas', value: '3' },
  { label: 'Baveria', value: '3' },
];

export const CountryName = [
  { label: 'United States', value: '1' },
  { label: 'Germany', value: '2' },
  { label: 'Canada', value: '3' },
  { label: 'Australia', value: '3' },
];

export const editMenu = [
  { label: 'Header Top', value: '1' },
  { label: 'Footer 1', value: '2' },
  { label: 'Footer 2', value: '3' },
  { label: 'Footer 3', value: '3' },
];

export const addBlogCategory = [
  { label: 'Travel Tips', value: '1' },
  { label: 'Car Reviews', value: '2' },
  { label: 'Rental Policies', value: '3' },
  { label: 'Insurance &amp; Coverage', value: '4' },
  { label: 'Budget Rentals', value: '5' },
];

export const couponsType = [
  { label: 'Percentage', value: '1' },
  { label: 'Fixed', value: '2' }
];

export const Applicable = [
  { label: 'New Customers', value: '1' },
  { label: 'Weekly Rentals', value: '2' },
  { label: 'VIP Members', value: '3' },
  { label: 'Luxury Cars', value: '4' },
  { label: 'Long Rentals', value: '5' },
];

export const invoiceCar = [
  { label: 'Ford Endeavour', value: '1' },
  { label: 'Ferrari 458 MM', value: '2' },
  { label: 'Ford Mustang', value: '3' },
  { label: 'Toyota Tacoma 4', value: '4' },
  { label: 'Chevrolet Truck', value: '5' },
];

export const invoiceCurrency = [
  { label: 'Dollor', value: '1' }
];

export const invoiceStatus = [
  { label: 'Paid', value: '1' },
  { label: 'Pending', value: '2' },
  { label: 'Overdue', value: '3' },
  { label: 'Unpaid', value: '4' },
];

export const invoiceFrom = [
  { label: 'Dreams Rent', value: '1' },
  { label: 'Ford Endeavour', value: '2' },
  { label: 'Ferrari 458 MM', value: '3' },
  { label: 'Ford Mustang', value: '4' },
  { label: 'Toyota Tacoma 4', value: '5' },
  { label: 'Chevrolet Truck', value: '6' },
];

export const invoicePayment = [
  { label: 'Bank Transfer', value: '1' },
  { label: 'Paypal', value: '2' },
];

export const MaintenanceStatus = [
  { label: 'Completed', value: '1' },
  { label: 'In Progress', value: '2' },
  { label: 'Planned', value: '2' },
];

export const InspectionsCar = [
  { label: 'Completed', value: '1' },
  { label: 'In Progress', value: '2' },
  { label: 'Planned', value: '2' },
];

export const InspectionBy = [
  { label: 'Shaun Farley', value: '1' },
  { label: 'Jenny Ellis', value: '2' },
  { label: 'Leon Baxter', value: '3' },
  { label: 'Karen Flores', value: '4' },
  { label: 'Michael Dawson', value: '5' },
];

export const InspectionStatus = [
  { label: 'Completed', value: '1' },
  { label: 'Inprogress', value: '2' },
  { label: 'Pending', value: '3' },
  { label: 'On Hold', value: '4' },
  { label: 'Rejected', value: '5' },
];

export const RepairStatus = [
  { label: 'Completed', value: '1' },
  { label: 'Inprogress', value: '2' },
  { label: 'Pending', value: '3' },
  { label: 'On Hold', value: '4' },
  { label: 'Need Repair', value: '5' },
];

export const BrandModel = [
  { label: 'Toyota', value: '1' },
  { label: 'Lamborghini', value: '2' },
  { label: 'BMW', value: '3' },
  { label: 'KIA', value: '4' },
  { label: 'Ferrari', value: '5' },
  { label: 'Honda', value: '6' },
  { label: 'Ford', value: '7' },
  { label: 'Hyundai', value: '8' },
  { label: 'Mercedes-Benz', value: '9' },
];




